import { render, staticRenderFns } from "./PostMainVideo.vue?vue&type=template&id=4a657d4d"
import script from "./PostMainVideo.vue?vue&type=script&lang=js"
export * from "./PostMainVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports